const merchandiseCredit = {
  merchandiseCredit: {
    noFile: 'Archivo no encontrado',
    fileName: 'Nombre del archivo',
    software_service: 'Servicio de software',
    hardware_product: 'Producto de hardware',
    sampleFileNameUs: 'Crédito de productos EE.UU.',
    sampleFileNameAu: 'Crédito de productos AU',
    rowNumber: 'Número de fila',
    errorMessage: 'Mensaje'
  }
};

export default merchandiseCredit;
